export default "__VITE_ASSET__DwBwVzNe__"